import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ICONS } from '../../../icons';
import CommonIconButton from '../../../components/common-icon-button/CommonIconButton';
import LabelSettingsModal from './label-settings-modal/LabelSettingsModal';

import scss from './SonarDashboardHeader.module.scss';

function SonarSettings() {
  const { t } = useTranslation('sidebar');
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleOpenSettings = () => {
    setIsSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setIsSettingsOpen(false);
  };

  return (
    <div className={scss.settingsIcon}>
      <CommonIconButton
        icon={ICONS.Settings}
        onClick={handleOpenSettings}
        isStrokeIcon
        tooltip={t('labelSettings')}
        ariaLabel={t('labelSettings')}
      />

      <LabelSettingsModal
        isOpen={isSettingsOpen}
        onCancel={handleCloseSettings}
        onClose={handleCloseSettings}
        onSubmit={() => null}
      />
    </div>
  );
}

export default SonarSettings;
